module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/1@2x_92aad7c72f08740e78a9f5d05fc342dd.png";